<sn-data-list #list reloadByQueryParams [fetchFn]="loadData">
  <sn-infinite-scroll windowScrollTarget>
    <sn-pull-to-refresh>
      <table mat-table [dataSource]="list.dataSource.data" class="mat-elevation-z0">
        <ng-container matColumnDef="agency">
          <th mat-header-cell *matHeaderCellDef>{{ 'common.agencyName' | t }}</th>
          <td mat-cell *matCellDef="let row">{{ row.agency }}</td>
        </ng-container>

        <ng-container matColumnDef="state">
          <th mat-header-cell *matHeaderCellDef>{{ 'common.state' | t }}</th>
          <td mat-cell *matCellDef="let row">{{ row.state }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>{{ 'common.status' | t }}</th>
          <td mat-cell *matCellDef="let row">
            <span *ngIf="row.status && statusTranslationKeys[row.status]" class="status"
                  [ngClass]="{
                    'status--pending': row.status === 'awaitingDecision',
                    'status--active': row.status === 'active',
                    'status--rejected': row.status === 'rejected'
                  }">
              {{ statusTranslationKeys[row.status] | t }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="lastUpdate">
          <th mat-header-cell *matHeaderCellDef>{{ 'vehicleIntelligence.lprSharing.lastUpdate' | t }}</th>
          <td mat-cell *matCellDef="let row">{{ row.lastUpdate }}</td>
        </ng-container>

        <ng-container matColumnDef="conditions">
          <th mat-header-cell *matHeaderCellDef>{{ 'vehicleIntelligence.lprSharing.conditions' | t }}</th>
          <td mat-cell *matCellDef="let row">{{ row.conditions && conditionTranslationKeys[row.conditions] ? (conditionTranslationKeys[row.conditions] | t) : '' }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row" class="actions-cell">
            <button mat-button class="vi-action-btn vi-action-btn--outline">{{ 'vehicleIntelligence.lprSharing.reciprocate' | t }}</button>
            <button mat-button class="vi-action-btn vi-action-btn--outline">{{ 'vehicleIntelligence.lprSharing.respond' | t }}</button>
            <button mat-icon-button [attr.aria-label]="'common.settings' | t">
              <mat-icon>settings</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: columns"></tr>
      </table>
    </sn-pull-to-refresh>
  </sn-infinite-scroll>
</sn-data-list>
